// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-qualified-teacher-layout {\n  padding: 25px; }\n  .modal-qualified-teacher-layout .title {\n    text-transform: uppercase;\n    font-family: Catamaran;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 30px;\n    /* identical to box height */\n    text-align: left;\n    color: var(--primary);\n    margin-bottom: 1rem; }\n", ""]);
// Exports
module.exports = exports;
